import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {MIHttpClientService} from '../shared/mi-http-client.service';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationService {

  constructor(
    private miClient: MIHttpClientService,
  ) {
  }

  getConfiguration(key: string): Observable<string> {
    const requestOptions: Object = { responseType: 'text' };
    return this.miClient.get<string>('configurations?key=' + encodeURIComponent(key), requestOptions, false);
  }

  getOrgConfiguration(key: string): string {
    const allConfigurations = this.getOrgConfigurationList();
    if (allConfigurations) {
      const filteredConfigs = allConfigurations.filter(config => config.name === key);
      if (filteredConfigs && filteredConfigs.length > 0) {
        return filteredConfigs[0].value;
      }
    }
    return null;
  }


  getOrgConfigurationList(): Configuration[] {
    return <Configuration[]>JSON.parse(localStorage.getItem('orgConfigurations'));
  }

  private getOrgConfigurations(): Observable<string> {
    return this.miClient.get<string>('configurations/all');
  }

  orgChanged(newOrgId: string): void {
    if (newOrgId === undefined || newOrgId === null) {
      return;
    }

    this.reloadOrgConfigurations();
  }



  private reloadOrgConfigurations(): void {
    const subscription = this.getOrgConfigurations()
      .subscribe(configurations => {
          localStorage.setItem('orgConfigurations', JSON.stringify(configurations));
        },
        error => console.log('Error receiving configurations'),
      );
  }




}

export interface Configuration {
  id: number,
  orgId: number,
  name: string,
  value: string
}
